/* eslint-disable camelcase */
/**
 * Created by zhaohaixi on 2018/10/8.
 */
/**
 * @function getZindex 获取当前zindex
 * @returns {number}
 */
import Cookie from 'js/lib/cookie'
import store from 'store'
import _$ from 'js/api/getdata'
import {
  getVersion, loginOut, fullscreenWnd, controlClientWnd as js2NativeControlClientWnd,
} from '@filez/js-2-native'

/**
 * 私有：601版本新自定义管理员
 */
export const ABILITYCODE = {
  ABILITY_FILE: 100,
  ABILITY_CUSTOM: 101,
  ABILITY_AD: 102,
  ABILITY_ACCOUNT_SETTING: 103,
  ABILITY_AUTO_FILE: 104,
  ABILITY_SECURITY: 105,
  ABILITY_DLP: 106,
  ABILITY_INTELLIGENCE: 107,
  ABILITY_ACCESS_MANAGE: 108,
  ABILITY_LOG: 109,
  ABILITY_STRATEGY: 110,
  ABILITY_MANAGEMENT: 111,
  ABILITY_ADMINISTRATOR_SETTING: 112,
  ABILITY_DOCUMENT_SETTING: 113,
  ABILITY_FOLDER_TEMPLATE: 114,
  ABILITY_STATISTICAL_ANALYSIS: 115,
  ABILITY_RECYCLE_BIN: 116,
  ABILITY_LINK_MANAGEMENT: 117,
  ABILITY_ANNOUNCEMENT: 118,
  ABILITY_GLOBAL_WHITELIST: 119,
}
// 私有:自定义权限编码
const G_CUSTOM_AUTH_CODE = {
  preview: 1,
  download: 4,
  upload: 2,
  create: 32,
  delivery: 24,
  delete: 64,
  rename: 128,
  copy: 512,
  move: 256,
  comment: 2048,
  list: 1024,
}
// 私有:标准权限掩码
const G_STANDARD_AUTH_CODE = {
  preview: 3073,
  upload: 3130,
  download: 3613,
  'upload:download': 3647,
  edit: 4095,
  deny: 0,
  list: 1024,
}
/**
 * 通过权限掩码转换出对应的权限
 * @params {Number} code - 权限码值
 */
export function getCSSActionByCode(code) {
  let rs = ''
  const returnData = {}
  Object.keys(G_CUSTOM_AUTH_CODE).forEach((o) => {
    if ((code & G_CUSTOM_AUTH_CODE[o]) === G_CUSTOM_AUTH_CODE[o]) {
      if (rs !== '') {
        rs += `:${o}`
      } else {
        rs = o
      }
    }
  })
  returnData.authCSS = rs
  Object.keys(G_STANDARD_AUTH_CODE).forEach((i) => {
    if (code === G_STANDARD_AUTH_CODE[i]) {
      returnData.authType = i
    }
    if (!returnData.authType) {
      returnData.authType = 'custom'
    }
  })
  return returnData
}
/*
 * 判断是否有某种权限
 * @params {Number} accessMode - 权限码值
 * @params {String} authname - 权限名称
 * */
export const ifHasAuth = (accessMode, authname) => {
  const action = getCSSActionByCode(accessMode).authCSS
  return action.split(':').includes(authname)
}

export function isCustomAdministrator(abilitycode) {
  const abilites = store.state.lenovoData.LenovoData.ability
  if (!abilites) return
  if (typeof abilitycode === 'number') {
    return abilites.includes(abilitycode)
  } if (Array.isArray(abilitycode)) { // 按照私有代码逻辑，只要出现给定的权限码中有一个为假 则返回假
    for (let i = 0; i < abilites.length; i += 1) {
      if (!abilites[i].includes(abilitycode)) {
        return false
      }
    }
    return true
  }
  return console.error('isCustomAdministrator\'s argument should be Number or Array')
}

/**
 * 判断是否为ie9
 */
export function isInternetExplorer9() {
  const b_version = navigator.appVersion
  const version = b_version.split(';')
  if (version.length > 1) {
    const trim_Version = parseInt(version[1].replace(/[ ]/g, '').replace(/MSIE/g, ''))
    if (trim_Version <= 9) {
      return true
    }
  }
  return false
}


/**
 * 获取文件类型
 * @param {string} typeIcon mime格式
 * @returns {string} 文件类型
 */
export function typeIcon(typeIcon) {
  const jar = {
    folder_share_oversea: 'folder_share_oversea',
    folder_share_private: 'folder_share_private',
    folder_team_oversea: 'folder_team_oversea',
    folder_team_private: 'folder_team_private',
    folder_oversea: 'folder_oversea',
    folder_private: 'folder_private',

    folder_team: 'folder_team',
    folder_share: 'folder_share',
    folder: 'folder',
    '': 'folder',
    doc: 'word',
    docx: 'word',
    rtf: 'word',
    dwg: 'cad',
    dxf: 'cad',
    dwt: 'cad',
    dws: 'cad',
    txt: 'text',
    dps: 'dps',
    vsd: 'visio',
    et: 'et',
    vsdx: 'visio',
    vdx: 'visio',
    wps: 'wps',
    mpp: 'mpp',
    jpg: 'pic',
    JPG: 'pic',
    jpeg: 'pic',
    JPEG: 'pic',
    png: 'pic',
    PNG: 'pic',
    bmp: 'pic',
    BMP: 'pic',
    gif: 'pic',
    GIF: 'pic',
    tif: 'pic',
    tiff: 'pic',
    TIFF: 'pic',
    pcx: 'pic',
    thm: 'pic',
    yuv: 'pic',
    pps: 'ppt',
    ppsx: 'ppt',
    ppt: 'ppt',
    pptx: 'ppt',
    xls: 'excel',
    xlsx: 'excel',
    xlsm: 'excel',
    csv: 'excel',
    lock: 'lock',
    pct: 'pdf',
    pdf: 'pdf',
    pmd: 'pdf',
    mp3: 'music',
    wma: 'music',
    ra: 'music',
    ram: 'music',
    ape: 'music',
    flac: 'music',
    wav: 'music',
    aac: 'music',
    ac3: 'music',
    amr: 'music',
    m4a: 'music',
    m4r: 'music',
    ogg: 'music',
    wv: 'music',
    mp2: 'music',
    avi: 'video',
    mov: 'video',
    mpg: 'video',
    mp4: 'video',
    mpeg: 'video',
    xv: 'video',
    '3gp': 'video',
    divx: 'video',
    rm: 'video',
    rmvb: 'video',
    asf: 'video',
    wmv: 'video',
    mkv: 'video',
    flv: 'video',
    '3g2': 'video',
    asx: 'video',
    ts: 'video',
    m3u8: 'video',
    webm: 'video',
    exe: 'exe',
    rar: 'zip',
    zip: 'zip',
    zipx: 'zip',
    '7z': 'zip',
    cab: 'zip',
    arj: 'zip',
    jar: 'zip',
    lzh: 'zip',
    bin: 'zip',
    deb: 'zip',
    gz: 'zip',
    rpm: 'zip',
    sit: 'zip',
    sitx: 'zip',
    tar: 'zip',
    cad: 'cad',
    dxf: 'cad',
    psd: 'ps',
    ai: 'ai',
    dw: 'dw',
    fl: 'fl',
    id: 'id',
    ae: 'ae',
    '3d': '3d',
    eps: 'pic',
    svg: 'svg',
    cdr: 'svg',
    cdr: 'svg',
    '': 'other',
    other: 'other',
    pages: 'other',
    log: 'other',
    msg: 'other',
    // "wps": "other",
    xps: 'other',
    chm: 'other',
    pdg: 'other',
    key: 'other',
    efx: 'other',
    sdf: 'other',
    vcf: 'other',
    wks: 'other',
    munbers: 'other',
    '3dm': 'other',
    max: 'other',
    com: 'other',
    bat: 'other',
    scr: 'other',
    lib: 'other',
    app: 'other',
    cgi: 'other',
    gadget: 'other',
    vb: 'other',
    wsf: 'other',
    accdb: 'other',
    db: 'other',
    dbf: 'other',
    mdb: 'other',
    pdb: 'other',
    sql: 'other',
    cpl: 'setting',
    cur: 'setting',
    dll: 'setting',
    dmp: 'setting',
    drv: 'setting',
    lnk: 'setting',
    sys: 'setting',
    cfg: 'setting',
    ini: 'setting',
    keychain: 'setting',
    prf: 'setting',
    c: 'cpp',
    class: 'cpp',
    cpp: 'cpp',
    cs: 'cpp',
    dtd: 'cpp',
    fil: 'cpp',
    java: 'cpp',
    m: 'cpp',
    pl: 'cpp',
    py: 'cpp',
    html: 'html',
    htm: 'html',
    xhtml: 'html',
    php: 'html',
    css: 'html',
    js: 'html',
    xml: 'html',
    asp: 'html',
    cer: 'html',
    rss: 'html',
    ttf: 'font',
    fnt: 'font',
    otf: 'font',
    fon: 'font',
    dmg: 'iso',
    toast: 'iso',
    vcd: 'iso',
    iso: 'iso',
    au: 'au',
    prproj: 'prproj',
    max: 'max',
    sketch: 'sketch',
    rp: 'rp',
    numbers: 'numbers',
    pages: 'pages',
    key: 'key',
    apk: 'apk',
    // 2021版本新增支持显示icon的文件类型
    ods: 'excel',
    xlsb: 'excel',
    one: 'other',
    onetoc2: 'other',
    odp: 'ppt',
    pot: 'ppt',
    potm: 'ppt',
    potx: 'ppt',
    ppsm: 'ppt',
    pptm: 'ppt',
    docm: 'other',
    dot: 'word',
    dotm: 'word',
    dotx: 'word',
    odt: 'word',
  }
  for (const value in jar) {
    if (typeIcon === value) {
      return jar[value]
    }
  }
  return 'other'
}

/*
 *判断是否为客户端（pc或者mac）
 */
export function isClient() {
  if (Cookie.get('Client-Agent')) {
    return true
  }
  return false
}

/**
 * 获取系统所在路径
 * @param {String} key
 *
 */
export const sysConfig = (key) => {
  const config = {
    custom_product_zh_name: '联想企业网盘',
    custom_product_en_name: 'Lenovo Box',
    custom_company_space_zh_name: '企业空间',
    custom_company_space_en_name: 'Enterprise space',
    custom_my_space_zh_name: '个人文件',
    custom_my_space_en_name: 'My space',
    custom_my_file_en_name: 'My files',
    custom_default_selected_node: 'ent',
    custom_preview_type: 'owa',
    custom_login_logo: '/config/get_file?config_type=0&config_id=0&name=custom_login_logo',
    custom_main_logo: '/config/get_file?config_type=0&config_id=0&name=custom_main_logo',
    custom_main_color: '157BF8',
    custom_banner_font_color: 'FFFFFF',
  }
  return config[key]
}

/*
 * 判断客户端是pc还是mac
 */
export function isPC() {
  if (Cookie.get('Client-Agent') && Cookie.get('Client-Agent').indexOf('LDClientWin') > -1) {
    return true
  }
  return false
}
export function isMac() {
  if ((Cookie.get('Client-Agent') && Cookie.get('Client-Agent').indexOf('LDClientMac') > -1) || ((navigator.userAgent.indexOf('Mac OS') > -1) && window.jsToNative)) {
    return true
  }
  return false
}
/**
 * 获取客户端的版本
 */
export async function clientVersion() {
  const getVersionData = await getVersion()
  return JSON.parse(getVersionData).originResult.version
}
/*
 *校验文件名称
 * */
export function validFilename(filename) {
  const reg = /[\/:*?"<>|\\]/
  if (reg.test(filename)) {
    return false
  }
  return true
}
/*
 * 校验文件夹名称全是...
 * */
export function validFolderName2(foldername) {
  if (foldername == '.' || foldername == '..') {
    return true
  }
  return false
}
/*
 * 校验是否为空或者空格
 * */
export function validEmpty(name) {
  const regEmpty = '^[ ]+$'
  const reEmpty = new RegExp(regEmpty)
  if (name === '' || reEmpty.test(name)) {
    return false
  }
  return true
}
/*
 * 校验是否为数字
 * */
export function validNumber(number) {
  const reg = /^\d+$/
  return reg.test(number)
}
/*
 * 校验邮箱格式
 * */
export function validEmail(email) {
  const emailtest = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/
  return emailtest.test(email)
}
/**
 * 校验手机号地址
 */
export function validPhone(value) {
  const mtest = /^1[3-9]\d{9}$/
  return mtest.test(value)
}
/*
* 判断是否能够添加和编辑标签
* 1.具有编辑者权限
*
* */
export function canTag(access_mode) {
  return isHasAuth(access_mode, 'edit')
}
/**
 * 文件是否能预览
 */
export function canPreview(mime) {
  return /\.(doc|pdf|txt|wps|mpp|dps|vsd|et|ppt|xls|docx|pptx|xlsx|png|jpeg|jpg|gif|bmp|pic|word|excel|psd|tiff|TIFF|TIF|JPG|JPEG|PNG|tif|eps|ai|dwg|dxf|dwt|dws|part|rar|zip|xlsm|avi|mov|mpg|mp4|mpeg|3gp|rm|rmvb|asf|wmv|mkv|flv|m3u8|ts|webm|mp3|wma|ra|ram|ape|flac|wav|aac|ac3|amr|m4a|m4r|ogg|wv|mp2|ods|xlsb|odp|pot|potm|potx|pps|ppsm|ppsx|pptm|odt|dot|dotm|dotx)$/.test(mime)
}

/**
* 文件是音频视频
*/
export function isAudioOrVideo(mime) {
  return /\.(avi|mov|mpg|mp4|mpeg|3gp|rm|rmvb|asf|wmv|mkv|flv|m3u8|ts|webm|mp3|wma|ra|ram|ape|flac|wav|aac|ac3|amr|m4a|m4r|ogg|wv|mp2)$/.test(mime)
}

/**
 * 文件是否为支持打开的压缩包
*/
export function canSupportOpenCompressFile(mime) {
  return /\.(rar|zip|7z)$/.test(mime)
}

/**
* 文件是压缩包
*/
export function isCompressedFile(mime) {
  return /\.(exe|rar|zip|7z|cab|arj|jar|lzh|bin|deb|gz|rpm|sit|sitx|tar)$/.test(mime)
}

/**
 * 文件是否能创建smartshare
 */
export function canSmartshare(mime) {
  return /\.(doc|pdf|txt|wps|dps|et|ppt|xls|docx|pptx|xlsx|png|jpeg|jpg|gif|psd|tif|eps|ai|mpp|vsd|)$/.test(mime)
}

export function getPrivatePrivilege(cssAction) {
  // 自定义权限定义什么就是什么权限，都是单个原子权限
  // 组合权限则可能不一定具有本身的权限
  // eg:上传者可以有创建目录的权限
  // eg:下载者可以预览还可以复制，仅仅下载又无法预览和复制，
  //    所以要剔除原子下载权限(download0)
  return {
    canPreview: /preview|edit|download\b|download-\w+/.test(cssAction),
    canUpload: /upload|edit/.test(cssAction),
    canDownload: /download|edit/.test(cssAction),
    canLink: /delivery|edit/.test(cssAction),
    canCreate: /create|edit|upload\b|upload-\w+/.test(cssAction),
    canDelete: /delete|edit/.test(cssAction),
    canRename: /rename|edit/.test(cssAction),
    canMove: /move|edit/.test(cssAction),
    canCopy: /copy|download\b|download-\w+|edit/.test(cssAction),
  }
}
/*
* 文件能否在线编辑
* */
export function canEditType(mime) {
  return /\.(doc|dps|wps|et|ppt|xls|docx|pptx|xlsx)$/.test(mime)
}
/*
 * 文件能否本地编辑
 * */
export function canEditNativeType(mime) {
  if (isSafari()) {
    return false
  }
  // 恢复mac别的浏览器得本地打开
  if (isMacOs()) {
    // |txt产品要求去掉
    // cms暂时没办法改，所以mac全都不显示可以本地编辑
    return /\.doc|ppt|xls|wps|et|dps|psd/.test(mime)
  }
  return true
}
/*
* 判断是否有在线编辑功能（私有逻辑）
* 1.需要上传下载下载权限
* 2.需要开启docs docsLimitEnable ===1
* 3.需要后端配置license local_edit_switch === true
*/
export function canEditOL(accessMode) {
  if (!accessMode) return
  const { custominfo, userInfo } = store.getters
  const { is_open_wps_edit: isOpenWpsEdit } = store.state.curFileInfo
  let flag = false
  if (!userInfo) {
    return
  }
  if (custominfo && ifHasAuth(accessMode, 'upload') && ifHasAuth(accessMode, 'preview')) {
    if (isOpenWpsEdit === 'true') {
      flag = true
      return flag
    }
    if (custominfo.custom_preview_type.indexOf('lenovoDocs') > -1) {
      if (userInfo.docsLimitEnable === 1 || userInfo.docsLimitEnable === 2) {
        flag = true
      }
    }
  }
  return flag
}
/*
* 判断是否有新建链接的权限
*/
export function cancommonLink(access_mode) {
  const { delivery_support } = store.getters.accountConfig
  return delivery_support && isHasAuth(access_mode, 'delivery')
}
/*
* 判断是否有editNative功能
* 1.至少具有预览和上传和新建权限
*（WEB端本地编辑不是原子权限）
*/
export function canEditNative(access_mode) {
  const isSafari = /mac/.test(navigator.userAgent.toLowerCase())
  if (store.getters.accountConfig && !isMac() && !isSafari && !isClient()) {
    if (store.getters.accountConfig.pageoffice_local_edit == 'true') {
      return isHasAuth(access_mode, 'preview') && isHasAuth(access_mode, 'upload') && isHasAuth(access_mode, 'create')
    }
  } else {
    return false
  }
}
/*
* 判断是否有localEdit功能
*（需要同时具有上传和下载权限，客户端本地打开功能才开启）
*/
export function canLocalEdit({ access_mode: accessMode }) {
  if (isClient()) {
    return ifHasAuth(accessMode, 'upload')
      && ifHasAuth(accessMode, 'download')
  }
  return false
}

/*
* 当前元素是否聚焦
* */
export function hasFoucs(element) {
  return document.activeElement === element
}

/**
 * 当前语言
 * @param baseNumber
 * @returns {*}
 */
export function getLanguage() {
  let cookieLang = Cookie.get('language')
  let localLang = window.localStorage.getItem('language')
  if (cookieLang && (cookieLang !== 'zh' && cookieLang !== 'en' && cookieLang !== 'tw')) {
    cookieLang = 'zh'
  }
  if (localLang && (localLang !== 'zh' && localLang !== 'en' && localLang !== 'tw')) {
    localLang = 'zh'
  }
  return cookieLang || localLang || 'zh'
}


/**
 * 设置当前语言环境
 * @param lang 当前语言 'en', 'zh', 'tw'
 */
export function setLanguage(lang) {
  Cookie.set('language', lang, { path: '/',  expires: 365 * 24 * 60 * 60 })
  window.localStorage.setItem('language', lang)
}


/**
 * 当前用户角色,admin:大管理员，team：团队管理员，member：普通成员
 * @param baseNumber
 * @returns {*}
 */
export function userType() {
  const userRole = store.state.lenovoData.userInfo.role
  const teamRole = store.state.lenovoData.userInfo.team_admin
  return userRole === 'admin' ? 'admin' : (userRole === 'member' && teamRole === true) ? 'team' : 'member'
}
/**
 * 格式化文件大小
 * @param {*} baseNumber
 */
export function formatBytes(baseNumber) {
  let i; let unit; let unitLabel
  const unitDivisors = [1099511627776, 1073741824, 1048576, 1024, 1]
  const unitLabels = ['TB', 'GB', 'MB', 'KB', 'B']
  if (baseNumber === 0) {
    return `0 ${unitLabels[unitLabels.length - 1]}`
  }

  unit = baseNumber
  unitLabel = unitLabels.length >= unitDivisors.length ? unitLabels[unitDivisors.length - 1] : ''
  for (i = 0; i < unitDivisors.length; i++) {
    if (baseNumber >= unitDivisors[i]) {
      unit = (baseNumber / unitDivisors[i]).toFixed(2)
      unitLabel = unitLabels.length >= i ? ` ${unitLabels[i]}` : ''
      break
    }
  }
  return unit + unitLabel
}

/**
 * 传入一个表示size的带单位的字符串，转化成字节
 * @param {string} fileSize
 */
export function getSizeNum(fileSize) {
  let idx = fileSize.length - 1
  let size = 0
  for (let i = fileSize.length - 1; i >= 0; i--) {
    if (!isNaN(+fileSize[i])) {
      idx = i + 1
      break
    }
  }
  const num = +fileSize.substring(0, idx)
  const level = fileSize.substring(idx).toLowerCase()
  if (typeof num === 'number' && num >= 0) {
    switch (level) {
      case 'byte': case 'b':
        size = num * 1
        break
      case 'kb': case 'k':
        size = num * 1024
        break
      case 'mb': case 'm':
        size = num * 1024 * 1024
        break
      case 'gb': case 'g':
        size = num * 1024 * 1024 * 1024
        break
      case 'tb': case 't':
        size = num * 1024 * 1024 * 1024 * 1024
        break
    }
    return size
  }
}
/**
 * 解析路径, 返回 文件名和文件后缀 对象
 *@param path 路劲
*@param flag 是否是文件夹
*/
export function resolvePath(path, flag) {
  const regName = /\/([^\/]+)$/
  const exSuffix = /\.(\w+){1}(\.\d+){0,}$/
  let name; let
    suffix = ['', '']
  if (!path) return ''
  name = path.match(regName)
  if (!flag && name && name[1]) {
    suffix = name[1].match(exSuffix)
  }
  return {
    name: name && name[1] || '',
    type: flag ? 'folder' : (suffix && suffix[1].toLowerCase()) || '', // 解决文件没有后缀名问题
  }
}

export function invalidSession() {
  if (location.pathname == '/user/reg') {
    location.href = '/user/reg'
  } else if (isClient()) {
    // mac.pc客户端session过期后登出
    loginOut()
  } else {
    if (isMobile()) {
      window.location.href = '/H5/'
      return
    }
    window.location.href = '/'
  }
}

export function isValidSession(callback) {
  _$.getData('getUserInfo').then((res) => {
    if (res.status === 200) {
      callback && callback()
      return
    }
    invalidSession()
  }).catch((e) => {
    console.log(e)
  })
}

/**
 * 获取当前文件父级路径  /top1/top2/1.jpg => top1/top2
 */
export function getParentPath(path) {
  let parentPath = path.substring(0, path.lastIndexOf('/'))
  if (parentPath === '/') {
    parentPath = ''
  }
  return parentPath
}
/**
 * 对文件路径进行encode操作
 */
export function encodePath(path) {
  let encodedUrl = encodeURI(path)
  encodedUrl = encodedUrl.replace(/\+/g, '%2B')
  encodedUrl = encodedUrl.replace(/#/g, '%23')
  return encodedUrl
}
export function styleSwap(elemArg, styleObj, calllback) {
  const oldStyle = {}
  const elem = elemArg
  Object.keys(styleObj).forEach((key) => {
    oldStyle[key] = elem.style[key]
    elem.style[key] = styleObj[key]
  })
  calllback(elem)
  Object.keys(oldStyle).forEach((name) => {
    elem.style[name] = oldStyle[name]
  })
}
/**
 *
 * @param {ElementNode} elem            从这个元素
 * @param {ElementNode} untilElem       到这个元素的Offset  不填就是到body
 */
export function getOffsetTopLeft(elem, untilElem) {
  const showCss = { display: 'block', visibility: 'hidden', position: 'absolute' }
  let parent = elem
  let left = 0
  let top = 0

  while (parent !== untilElem && parent) {
    if (parent.style.display === 'none') {
      styleSwap(parent, showCss, (elem) => {
        top += elem.offsetTop
        left += elem.offsetLeft
      })
    } else {
      top += parent.offsetTop
      left += parent.offsetLeft
    }
    parent = parent.offsetParent
  }
  return { top, left }
}

/**
 *
 * @param {ElemetNode} elem
 * @param {string} type 仅支持 'height'和'width'
 */
export function getWidthOrHeight(elem, type) {
  if (!elem) return 0
  const showCss = { display: 'block', visibility: 'hidden', position: 'absolute' }
  const view = elem.ownerDocument.defaultView || window
  const computed = view.getComputedStyle(elem)
  const Type = `offset${type.replace(/^([a-z])/, (str) => str.toUpperCase())}`
  const reg = /[^\d]+/g
  let ret
  let prop
  if (computed) {
    prop = computed.getPropertyValue(type)
    if (!prop.replace(reg, '') && !elem[Type]) {
      styleSwap(elem, showCss, (elem) => {
        ret = elem[Type]
      })
    } else {
      ret = elem[Type]
    }
  } else {
    prop = elem.style[type]
    if (!prop.replace(reg, '') && elem[Type]) {
      styleSwap(elem, showCss, (elem) => {
        ret = elem[Type]
      })
    } else {
      ret = elem[Type]
    }
  }
  return ret
}


export function base64Img2Blob(code) {
  const parts = code.split(';base64,')
  const contentType = parts[0].split(':')[1]
  const raw = window.atob(parts[1])
  const rawLength = raw.length

  const uInt8Array = new Uint8Array(rawLength)

  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i)
  }

  return new Blob([uInt8Array], { type: contentType })
}


// 删除空对象 删除'', null, undefined
export function isEmpty(foo) {
  if (typeof foo === 'object') {
    for (const i in foo) {
      return false
    }
    return true
  }
  return foo === '' || foo === null || foo === undefined
}

/**
 * @description 输入类input将<>替换，预防xss攻击，后续能继续优化
 * @param {*} str
 */
export function escapeHTMLString(str) {
  str = str.replace(/</g, '&lt;')
  str = str.replace(/>/g, '&gt;')
  return str
}
/**
 * 判断是否是ie浏览器，而不是别的（包括edge）浏览器
 */
export function isIE() {
  return (!!window.ActiveXObject || 'ActiveXObject' in window)
}

/**
 * 判斷是否是safari
 */
export function isSafari() {
  const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)
  return isSafari
}
/**
 * 获取导航参数
 */

export function queryString(str) {
  str = str.substr(1)
  const keyValArr = str.split('&')
  const keyValObj = {}
  for (let i = 0, len = keyValArr.length; i < len; i++) {
    const a = keyValArr[i].split('=')
    if (a.length > 1) {
      keyValObj[a[0].toLowerCase()] = a[1]
    }
  }
  return keyValObj
}


/**
 * 时间格式化
 * @param {string|Date} date 时间戳或者时间对象
 * @param {string} format 时间格式
 */
export function formatDate(dateObj, fmt) {
  let year; let month; let date; let hours; let minutes; let
    seconds

  if (!dateObj) return

  if (Object.prototype.toString.call(dateObj) == '[object Date]') {
    year = dateObj.getFullYear()
    month = dateObj.getMonth() + 1
    date = dateObj.getDate()
    hours = dateObj.getHours()
    minutes = dateObj.getMinutes()
    seconds = dateObj.getSeconds()
  } else {
    const regexp = /([\d]{4})-([\d]{2})-([\d]{2})T([\d]{2}):([\d]{2}):([\d]{2})(?:\+([\d]{2}):([\d]{2}))?/
    const d = regexp.exec(dateObj)
    if (!d) return
    year = d[1], month = d[2], date = d[3], hours = d[4], minutes = d[5], seconds = d[6]
  }
  const o = {
    'M+': +month, // 月份
    'd+': +date, // 日
    'h+': +hours, // 小时
    'm+': +minutes, // 分
    's+': +seconds, // 秒
    'q+': Math.floor((+month + 3) / 3), // 季度
    // "S": d.getMilliseconds() //毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (`${year}`).substr(4 - RegExp.$1.length))
  for (const k in o) { if (new RegExp(`(${k})`).test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length))) }
  return fmt
}
/**
 * 获取时间是当前时间之前的什么 5分钟内表示刚刚
 * @param {string|Date} dateTimeStamp 时间戳或者时间对象
 */
export function timeago(dateTimeStamp) { // dateTimeStamp是一个时间毫秒，注意时间戳是秒的形式，在这个毫秒的基础上除以1000，就是十位数的时间戳。13位数的都是时间毫秒。
  let result = ''
  const minute = 1000 * 60 // 把分，时，天，周，半个月，一个月用毫秒表示
  const hour = minute * 60
  const day = hour * 24
  const now = new Date().getTime() // 获取当前时间毫秒
  const diffValue = Math.abs(now - dateTimeStamp)// 时间差
  if (diffValue < 0) {
    return
  }
  const minC = diffValue / minute // 计算时间差的分，时，天，周，月
  const hourC = diffValue / hour
  const dayC = diffValue / day

  const datetime = new Date()
  const currentYear = datetime.getFullYear()
  const currentMonth = datetime.getMonth() + 1
  const currentDate = datetime.getDate()

  datetime.setTime(dateTimeStamp)
  const oldYear = datetime.getFullYear()
  const oldMonth = datetime.getMonth() + 1
  const oldDate = datetime.getDate()

  const Nyear = oldYear
  const Nmonth = oldMonth < 10 ? `0${oldMonth}` : oldMonth
  const Ndate = oldDate < 10 ? `0${oldDate}` : oldDate
  const Nhour = datetime.getHours() < 10 ? `0${datetime.getHours()}` : datetime.getHours()
  const Nminute = datetime.getMinutes() < 10 ? `0${datetime.getMinutes()}` : datetime.getMinutes()
  if (currentYear === oldYear && currentMonth === oldMonth) {
    if (currentDate === oldDate) {
      if (hourC > 1 && hourC < 24) {
        result = `${app.$t('今天')} ${Nhour}:${Nminute}`
      } else if (minC >= 5 && minC <= 59) {
        result = ` ${parseInt(minC)}${app.$t('分钟前')}`
      } else if (diffValue >= 0 && diffValue <= minute * 5) {
        result = app.$t('刚刚')
      }
    } else if (currentDate - oldDate === 1) {
      result = `${app.$t('昨天')} ${Nhour}:${Nminute}`
    } else if (currentDate - oldDate === 2) {
      result = `${app.$t('前天')} ${Nhour}:${Nminute}`
    } else {
      result = `${Nmonth}-${Ndate} ${Nhour}:${Nminute}`
    }
  } else {
    result = `${Nyear}-${Nmonth}-${Ndate} ${Nhour}:${Nminute}`
  }
  return result
}
/**
 * 获取数据类型
 * @param {data} d
 */
export function getPreviewType(d) {
  let mimeType = d.mime_type
  const { support_preview: supportPreview } = d
  if (!mimeType) {
    return ''
  }
  if (mimeType.split('.')[1] === 'dwg') {
    mimeType = 'dwg'
  }
  mimeType = mimeType.split('/')
  mimeType = mimeType[0] || 'other'
  mimeType = supportPreview === 'false' ? 'other' : mimeType
  return mimeType
}

/*
* 解析 具有什么样的权限
* @param access_mode {{Number}} 权限参数
* */
export function parseAccessMode(access_mode) {
  const action = []; const
    atom = []
  if (access_mode == 2047) {
    action.push('edit')
  }
  if (access_mode == 1599) {
    action.push('upload')
    atom.push(2)
    action.push('download')
    atom.push(4)
    action.push('delivery')
    atom.push(24)
  }
  if (access_mode == 1575) {
    action.push('upload')
    atom.push(2)
    action.push('download')
    atom.push(4)
  }
  if (access_mode == 1565) {
    action.push('download')
    atom.push(4)
    action.push('delivery')
    atom.push(24)
  }
  if (access_mode == 1541) {
    action.push('download')
    atom.push(4)
  }
  if (access_mode == 1082) {
    action.push('upload')
    atom.push(2)
    action.push('delivery')
    atom.push(24)
  }
  if (access_mode == 1058) {
    action.push('upload')
    atom.push(2)
  }
  if (access_mode == 1025) {
    action.push('preview')
    atom.push(1)
  }
  if ((access_mode & 1) == 1) {
    action.push('preview')
    atom.push(1)
  }
  if ((access_mode & 2) == 2) {
    action.push('upload')
    atom.push(2)
  }
  if ((access_mode & 4) == 4) {
    action.push('download')
    atom.push(4)
  }
  if ((access_mode & 24) == 24) {
    action.push('delivery')
    atom.push(24)
  }
  if ((access_mode & 256) == 256) {
    action.push('move')
    atom.push(256)
  }
  if ((access_mode & 512) == 512) {
    action.push('copy')
    atom.push(512)
  }
  if ((access_mode & 128) == 128) {
    action.push('rename')
    atom.push(128)
  }
  if ((access_mode & 64) == 64) {
    action.push('delete')
    atom.push(64)
  }
  if ((access_mode & 32) == 32) {
    action.push('create')
    atom.push(32)
  }
  return {
    action,
    atom,
  }
}
/*
 * 判断是不是手机
 */
export function isMobile() {
  const deviceKeys = ['iPhone', 'iPad', 'iPod', 'Android', 'Mobile', 'SymbianOS', 'BlackBerry', 'Phone']
  for (let i = 0, len = deviceKeys.length; i < len; i++) {
    const index = navigator.userAgent.toLowerCase().indexOf(deviceKeys[i].toLowerCase())
    if (index != -1) {
      return true
    }
  }
  return false
}
/*
* 判断是否存在某一权限
* @param access_mode {{Number}} 权限编码
* @param access 权限
* @return 具有权限
* */
export function isHasAuth(access_mode, access) {
  const mode = parseAccessMode(access_mode)
  let authList = null
  if (typeof access === 'number') {
    authList = mode.atom
  } else if (typeof access === 'string') {
    authList = mode.action
  } else {
    authList = mode.action
  }
  const index = authList.indexOf(access)
  return index > -1
}
/**
 * 客户端全屏
 * @param {boolean} ifFullScreen true: 全屏 false:退出全屏
 */
export const clientFullScreen = (ifFullScreen) => {
  if (isClient()) {
    fullscreenWnd({
      fullscreen: ifFullScreen,
    })
  }
}

/*
h5全屏操作
 */
export function requestFullScreen(element) {
  const el = element instanceof HTMLElement ? element : document.documentElement
  const rfs = el.requestFullscreen
                || el.webkitRequestFullscreen
                || el.mozRequestFullScreen
                || el.msRequestFullscreen
  clientFullScreen(true)
  if (rfs) {
    rfs.call(el)
  } else if (window.ActiveXObject) {
    const ws = new ActiveXObject('WScript.Shell')
    ws && ws.SendKeys('{F11}')
  }
}
/**
 * h5取消全屏操作
 */
export function exitFullscreen() {
  const efs = document.exitFullscreen
            || document.webkitExitFullscreen
            || document.mozCancelFullScreen
            || document.msExitFullscreen
  clientFullScreen(false)
  if (efs) {
    efs.call(document)
  } else if (window.ActiveXObject) {
    const ws = new ActiveXObject('WScript.Shell')
    ws && ws.SendKeys('{F11}')
  }
}


/**
 * 定义doc_preview的常量设置
 */
export const _DOC_PERVIEW_PATH = {
  // base_path:'http://mytest.lenovows.com/v/doc_preview',  //基础预览地址
  base_path: '/v', // 基础预览地址
  file_preview: 'file', // 正常文件预览界面
  ver_preview: 'version', // 版本预览界面
  sm_preview: 'smartshare', // smartshare
}

/**
 * 检测是不是excel文件,是excel走owa且不出现pdftoolbar
 */
export function isExcel(type) {
  if (!type) return false
  let isExcelFile = false
  const dotIndex = type.lastIndexOf('.')
  const suffix = type.substring(dotIndex + 1).toLowerCase()
  switch (suffix) {
    case 'ods':
    case 'xls':
    case 'xlsb':
    case 'xlsm':
    case 'xlsx':
    case 'et':
      isExcelFile = true
      break
    default:
      isExcelFile = false
  }
  return isExcelFile
}


/**
* 外链文件的权限转化表
*/
export function resolveFileAction(access_mode) {
  if (access_mode == 2047) {
    return 'edit'
  }
  if (access_mode == 1599) {
    return 'upload:download:delivery'
  }
  if (access_mode == 1575) {
    return 'upload:download'
  }
  if (access_mode == 1565) {
    return 'download:delivery'
  }
  if (access_mode == 1541) {
    return 'download'
  }
  if (access_mode == 1082) {
    return 'upload:delivery'
  }
  if (access_mode == 1058) {
    return 'upload'
  }
  if (access_mode == 1025) {
    return 'preview'
  }
  const action = []
  if ((access_mode & 1) == 1) {
    action.push('preview')
  }
  if ((access_mode & 2) == 2) {
    action.push('upload0')
  }
  if ((access_mode & 4) == 4) {
    action.push('download0')
  }
  if ((access_mode & 24) == 24) {
    action.push('delivery')
  }
  if ((access_mode & 256) == 256) {
    action.push('move')
  }
  if ((access_mode & 512) == 512) {
    action.push('copy')
  }
  if ((access_mode & 128) == 128) {
    action.push('rename')
  }
  if ((access_mode & 64) == 64) {
    action.push('delete')
  }
  if ((access_mode & 32) == 32) {
    action.push('create')
  }
  // 返回权限表
  return action.join(':').replace(/:/g, '_').replace(/0|copy|move|rename|delete|create|delivery/g, '').replace(/_*$/, '')
}

export function isAllTeamDocAdmin() {
  if (isEntVersion()) {
    const entRole = store.state.lenovoData.userRole
    return entRole && entRole.indexOf('all_team_doc_admin') !== -1
  }
  return false
}

export function isAdmin() {
  if (isEntVersion()) {
    const entRole = store.state.lenovoData.userRole

    return entRole && entRole.indexOf('super_admin') !== -1
  }
  return store.getters.userInfo && store.getters.userInfo.role === 'admin'
}

export function isEntVersion() {
  return store.state.lenovoData && store.state.lenovoData.session && store.state.lenovoData.session.accountManageMode && store.state.lenovoData.session.accountManageMode === 'enterprise'
}
//是否为图片
export const isImage = (mime) => /\.(png|jpeg|jpg|bmp|gif|JPEG|JPG|GIF|BMP|psd|ai|eps|pic|tiff|TIFF|TIF|tif)/.test(mime)

//是否为音频
export const isVideo = (mime) => /\.(avi|wv|mpg|wma|mp4|mp2|flv|wmv|rmvb|mkv|ram|amr|m4r|vob|m4a|ogg)/.test(mime)

//是否为视频
export const isAudio = (mime) => /\.(mp3|aac|ape|flac|ra|wav|mpeg|rm|m3u8|ts|m4a|mpa|aiff|ac3|mov|amr|asf|3gp|webm)/.test(mime)

/**
 * 开启wps
 * @param {*} mime
 * @returns {boolean}
 */
export const isOpenWps = (mime) => {
  const mimeType = store.state.curFileInfo.wps_preview_type
  if (mimeType !== '') {
    const wpsMimeType = mimeType.replace(/\./g, '|').substr(1)
    const result = new RegExp(`\\.(${wpsMimeType})`).test(mime)
    return result
  }
}

/**
 * 外链支持预览的文件
 */
export function suppportPreview(params) {
  const pathname = window.location.pathname.substr(2)
  if (pathname.indexOf('/approve/view') > -1) {
    if (getQueryVariable('handlers') === '0') {
      return false
    }
  }
  return JSON.parse(params.support_preview)
}

/**
 * 常规支持预览的文件
 */
 export function suppportNormalPreview(params) {
  return JSON.parse(params.support_preview)
}

/**
 * 跳登陆
 * @param {*} options
 */
export function gotoLogin(options = {}) {
  // let queryStr = ''
  // let { querys } = options
  // if (querys && (querys.toLocaleString() === '[object Object]')) {
  //     for(let i in querys) {
  //         if (!queryStr) {
  //             queryStr = `${i}=${querys[i]}`
  //         } else {
  //             queryStr = `${queryStr}&${i}=${querys[i]}`
  //         }
  //     }
  // }
  // window.location.href = `/user/login?${queryStr}`
  const { href } = window.location
  const arr = href.split('/')
  window.location.href = `/user/login?deliveryCode=${arr[arr.length - 1]}`
}

/**
 * 定位更多下拉框
 * 目前分享和更多都改成fixed定位所以提成一个函数
 *
 * 合并 setLinkMenuPosition setMoreMenuPosition setEditMenuPostion
 * 按新的交互算位置，具操作按钮4px的距离
 */
export function setMenuPosition(e, menudom, pdom) {
  // 获取操作按钮的边界
  // let pBtn = this.$refs[prefname][0]
  const pBtn = pdom
  const pBtnBounding = pBtn.getBoundingClientRect()
  // 获取展开菜单的相关属性
  // let menu = this.$refs[refname][0],
  const menu = menudom
  const menuH = getWidthOrHeight(menu, 'height')
  const menuW = getWidthOrHeight(menu, 'width')
  // 现在是上下左右8px
  const le = 4
  // 获取浏览器的宽度
  const winWith = window.innerWidth
  const rWith = winWith - pBtnBounding.right - le

  // 算上下的距离，此时考滤 上下都不够的时候按比例显示
  const winHeight = window.document.documentElement.clientHeight

  // 距下距上
  const tHeight = pBtnBounding.top + le
  const bHeight = winHeight - pBtnBounding.bottom - le

  if (tHeight < menuH && bHeight < menuH) {
    // 整个列表的高度
    // let listEl = document.getElementById('list-wrapper')
    // let listH = listEl.offsetHeight

    // // 取当前按键到列表容器的高度 15 为按钮高度的一半
    // let toLisTtopH = pBtnBounding.top - (winHeight - listH) + 15
    // let toLisTbottomH = winHeight - pBtnBounding.bottom + 15

    // // 比例
    // let rate =toLisTtopH/listH
    // let realT = Math.round(menuH*rate)
    // menu.style.top = `${pBtnBounding.bottom - realT}px`;
    // 如果底部距顶大于高度
    if (pBtnBounding.bottom > menuH) {
      // menu.style.bottom = `${winHeight - pBtnBounding.bottom + le}px` //加动效算法
      menu.style.top = `${pBtnBounding.bottom - menuH}px`
    } else {
      menu.style.top = '0px'
    }

    // 此时重新算左右
    if (rWith < menuW) {
      menu.style.left = `${pBtnBounding.left - menuW - le}px`
    } else {
      menu.style.left = `${pBtnBounding.right + le}px`
    }
    return
  }
  // 算居左还是居右 最小到1024 不考滤两边都不够的情况
  // 算是否居左，还是居右
  if (rWith < menuW) {
    menu.style.left = `${pBtnBounding.right - menuW}px`
  } else {
    menu.style.left = `${pBtnBounding.left}px`
  }
  if (bHeight < menuH) {
    // menu.style.bottom = `${winHeight - pBtnBounding.bottom + 30 + le}px` //动效算法
    menu.style.top = `${pBtnBounding.top - menuH - le}px`
  } else {
    menu.style.top = `${pBtnBounding.bottom + le}px`
  }
}

/**
 * 去除对象中所有符合条件的对象
 * @param {Object} obj 来源对象
 * @param {Function} fn 函数验证每个字段
 */
export function compactObj(obj, fn) {
  for (const i in obj) {
    if (typeof obj[i] === 'object') {
      compactObj(obj[i], fn)
    }
    if (fn(obj[i])) {
      delete obj[i]
    }
  }
}

/**
 * 判斷是否是mac操作系统
 */
export function isMacOs() {
  return /macintosh|mac os x/i.test(navigator.userAgent)
}
/**
 * 判断是否是Linux系统
 */
export function isLinux() {
  return /linux/i.test(navigator.userAgent)
}
/*
* url解析
*
*/
export function urlParse(url) {
  if (url) {
    const parser = document.createElement('a')
    parser.href = url
    return parser
  }
  return {}
}

/*
* 多域名替换
*
*/
export function resolveMultiDomain(url, isReplace) {
  if (isReplace === false) {
    return url
  }
  const { host } = location
  if (new RegExp('zbox.filez.com').test(host)) { // 替换为fileZ的域名
    const urlObject = urlParse(url)
    const hostName = urlObject.hostname
    const regDomain = /.*\.box\.lenovo\.com/

    if (hostName === 'box.lenovo.com') {
      // 官网
      url = url.replace('box.lenovo.com', 'www.filez.com')
    } else if (regDomain.test(hostName)) {
      // 非官网 *.box.lenovo.com
      url = url.replace('box.lenovo.com', 'zbox.filez.com')
    }
  } else if (new RegExp('box.lenovo.com.cn').test(host) && !(new RegExp('box.lenovo.com.cn').test(url))) { // 替换cn
    url = url.replace('box.lenovo.com', 'box.lenovo.com.cn')
  }
  return url
}
/**
 * 获取url参数
 */
export function getQueryVariable(variable) {
  const query = window.location.search.substring(1)
  const vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=')
    if (pair[0] === variable) { return pair[1] }
  }
  return false
}
/**
 * 处理特殊尾缀的域名
 * @param {*} hostname
 */
export function findOtherdomain(hostname) {
  const sDomain = ['.com.cn', '.net.cn', '.org.cn', '.gov.cn']
  const ishasOtherDomain = sDomain.some((item) => {
    const difflen = hostname.length - item.length
    return difflen > 0 && hostname.lastIndexOf(item) === difflen
  })
  return ishasOtherDomain
}
/*
* 私有：web本地编辑
* 满足：1.local_edit_switch === true
*      2.有上传下载能力
* */
export const privateCloudCanLocalEdit = (accessMode) => {
  let flag = false
  if (!isClient() && ifHasAuth(accessMode, 'upload') && ifHasAuth(accessMode, 'download')) {
    flag = store.getters.accountInfo && store.getters.accountInfo.local_edit_switch
  }
  return flag
}
/*
* 私有:文件能否本地编辑
* @params {String} mime-文件类型
* */
export function privateCloudCanLocalEditType(mime) {
  if (isMacOs()) { // mac上不支持txt文件回传，所以取消mac的txt本地编辑入口
    return /\.(doc|dps|wps|et|ppt|xls|docx|pptx|xlsx)$/.test(mime)
  }
  return /\.(doc|dps|wps|et|ppt|xls|docx|pptx|xlsx|txt)$/.test(mime)
}
/**
 * 私有：控制台-用户是否开启了链接分享
 */
export const isUserLinkSharingEnable = () => store.getters.userInfo && store.getters.userInfo.linkSharingEnable === 1
/**
 * 私有：能否-新建链接
 * 企业目录：有delivery能力
 * 非企业目录(个人、我的共享、收到的共享、收藏)： 开启了新建链接 && 有delivery能力
 * @param {Object} currentData
 * @param {Number} currentData.access_mode 权限码
 * @param {String} currentData.path_type 文件所在目录类型
 */
export const canCreateNewLink = (currentData) => {
  const cur = currentData
  if (cur === null) return false
  const { access_mode: accessMode, path_type: pathType } = cur
  if (pathType === 'ent') {
    ifHasAuth(accessMode, 'delivery')
  }
  return isUserLinkSharingEnable() && ifHasAuth(accessMode, 'delivery')
}

export function isInternetExplorer10() {
  const bVersion = navigator.appVersion
  const version = bVersion.split(';')
  if (version.length > 1) {
    const trimVersion = parseInt(version[1].replace(/[ ]/g, '').replace(/MSIE/g, ''), 10)
    if (trimVersion <= 10) {
      return true
    }
  }
  return false
}

/**
 * @description 用于控制客户端窗口的显示状态
 * @param {String} Operate (show:显示,
 * hide:隐藏, close:关闭,
 * max:最大化, min:最小化,
 * top:显示到最上层)(PS:Mac端目前只有show，hide两个参数)
 * @param {String} WndName PC客户端窗口名称(例：MainWndTitle 右上角账号设置等按钮),Mac客户端没有该字段，只控制右上角按钮的显示隐藏
 *
 * */
export function controlClientWnd(Operate, WndName) {
  const params = {
    wndName: WndName || '',
    operate: Operate,
  }
  js2NativeControlClientWnd(params)
}

export function getOriginPath(fileInfo) {
  const lenovo = store.getters.custominfo
  const lang = getLanguage()
  const pathMap = {
    ent: lang === 'en' ? lenovo.custom_company_space_en_name : lenovo.custom_company_space_zh_name,
    self: lang === 'en' ? sysConfig('custom_my_file_en_name') : sysConfig('custom_my_space_zh_name'),
    share_in: window.i18n.t('收到的共享'),
    share_out: window.i18n.t('我的共享'),
  }
  return `/${pathMap[fileInfo.path_type]}`
}

export const windowClient = () => !isMac() && isClient() && !isLinux()

export const unlockAdmin = (metaData) => {
  const { lock_uid: lockUid } = metaData
  return (lockUid === store.getters.uId) || isCustomAdministrator(ABILITYCODE.ABILITY_FILE)
}
// 将16进制的设置转化为rgb形式的对象
export const getRGBFromHexColor = (hex) => {
  const tem = parseInt(hex, 16)
  let r = tem >> 16
  r &= 0xff
  let g = tem >> 8
  g &= 0xff
  const b = tem & 0xff
  return {
    r, g, b,
  }
}
// 插入一个style标签
export const loadCssCode = (code) => {
  if (code) {
    const style = document.createElement('style')
    style.type = 'text/css'
    style.rel = 'stylesheet'
    try {
      // for Chrome Firefox Opera Safari
      style.appendChild(document.createTextNode(code))
    } catch (ex) {
      // for IE
      style.styleSheet.cssText = code
    }
    const head = document.getElementsByTagName('head')[0]
    head.appendChild(style)
  }
}
// 根据接口返回的数据设置关键色的色值！
export const getButtonPrimaryCssCode = () => {
  let { custom_main_color: primaryColor = '0A64FA', custom_banner_font_color: textColor = 'FFFFFF' } = store.state.lenovoData.LenovoData
  primaryColor = primaryColor.trim().padStart(7, '#').toUpperCase()
  textColor = textColor.trim().padStart(7, '#').toUpperCase()

  if (primaryColor === '#0A64FA' && textColor === '#FFFFFFF') { // UI 认为默认的按钮颜色需要和其他的不一致
    return false
  }

  const { r: primaryR, g: primaryG, b: primaryB } = getRGBFromHexColor(primaryColor.substring(1))
  const primary = `${primaryColor} !important`
  const primaryTextColor = `${textColor} !important`
  const hoverColor = `rgba(${primaryR}, ${primaryG}, ${primaryB}, 0.8) !important`
  const disableColor = `rgba(${primaryR}, ${primaryG}, ${primaryB}, 0.6) !important`
  const transparent = 'transparent !important'

  return `
    /** primary按钮 **/
    .s-btn{
      color: ${primaryTextColor};
      background: ${primary};
      border-color: ${primary};
    }
    .s-btn:not(.disabled):hover{
      background: ${hoverColor};
      border-color: ${transparent};
    }
    .s-btn:not(.disabled):active{
      background: ${primary};
      border-color: ${primary};
    }
    .s-btn.disabled,
    .default-btn.disabled{
      background: ${disableColor};
      border-color: ${transparent};
    }
    /** 普通按钮 **/
    .c-btn:not(.disabled):hover{
      color: ${primaryTextColor};
      background: ${hoverColor};
      border-color: ${transparent};
    }
    .c-btn:not(.disabled):active{
      background: ${primary};
      border-color: ${primary};
    }
    /** 分页按钮 **/
    .c-btn.is-plain:not(.disabled):hover{
      border-color: ${primary};
      background: #fff !important;
      color: ${primary};
    }
  `
}

/**
 * 获取文件夹类型
 * @param {boolean} type.is_team 团队
 * @param {boolean} type.is_shared 共享
 * @return 文件夹类型
 * */
export function getFolderType(type) {
  let typeIconName = 'folder'

  const normalWeights = 0 // 普通文件夹权重为0
  const shareWeights = type.is_shared ? 1 : 0 // 这个文件夹的共享权重
  const teamWeights = type.is_team ? 2 : 0 // 这个文件夹的团队权重
  const weights = Math.max( // 找到文件夹占权重最大那个，显示具体的图标
    normalWeights,
    shareWeights,
    teamWeights,
  )
  switch (weights) {
    case 0:
      break
    case 1:
      typeIconName = 'folder-share'
      break
    case 2:
      typeIconName = 'folder-team'
      break
    default:
      break
  }
  return typeIconName
}

/*
 *校验文件夹名称
 * */
export function validFolderName(foldername) {
  const reg = /[/:*?"<>|\\]/
  if (reg.test(foldername)) {
    return false
  }
  return true
}

export function pathToName(path) {
  return path.split('/').pop()
}
export function getUserID() {
  return store.getters.userInfo ? store.getters.userInfo.uid : -1
}
export const ifSearchPage = () => {
  const currentRooteName = window.Router.currentRoute.name
  return currentRooteName.indexOf('-search') !== -1 || currentRooteName.indexOf('-tag') !== -1
}
/**
 * 浏览器类型判断
 */
export const BrowserType = () => {
  const { userAgent } = navigator // 取得浏览器的userAgent字符串
  const isOpera = userAgent.indexOf('Opera') > -1 // 判断是否Opera浏览器
  // var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera; //判断是否IE浏览器
  const isie = window.ActiveXObject || 'ActiveXObject' in window
  // var isEdge = userAgent.indexOf("Windows NT 6.1; Trident/7.0;") > -1 && !isIE; //判断是否IE的Edge浏览器
  const isEdge = userAgent.indexOf('Edge') > -1 // 判断是否IE的Edge浏览器
  const isFF = userAgent.indexOf('Firefox') > -1 // 判断是否Firefox浏览器
  const issafari = userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1 // 判断是否Safari浏览器
  const isChrome = userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Safari') > -1 && !isEdge // 判断Chrome浏览器

  if (isie) {
    const reIE = new RegExp('MSIE (\\d+\\.\\d+);')
    reIE.test(userAgent)
    const fIEVersion = parseFloat(RegExp.$1)
    if (userAgent.indexOf('MSIE 6.0') !== -1) {
      return 'IE6'
    } if (fIEVersion === 7) { return 'IE7' }
    if (fIEVersion === 8) { return 'IE8' }
    if (fIEVersion === 9) { return 'IE9' }
    if (fIEVersion === 10) { return 'IE10' }
    if (userAgent.toLowerCase().match(/rv:([\d.]+)\) like gecko/)) {
      return 'IE11'
    }
    return '0'// IE版本过低
  }// isIE end

  if (isFF) { return 'FF' }
  if (isOpera) { return 'Opera' }
  if (issafari) { return 'Safari' }
  if (isChrome) { return 'Chrome' }
  if (isEdge) { return 'Edge' }
}
/**
 * 比较两个客户端版本大小
 * @param {string} version1
 * @param {string} version2
 * @returns {number} -1 version1 小 0 相等 1 version 大
 */
export function compareVersion(version1, version2) {
  if (version1 === version2) {
    return 0
  }
  let num = version1.split('.')
  let baseNum = version2.split('.')
  for (let i = 0; i < num.length; i++) {
    let v = +num[i] || 0
    let n = +baseNum[i] || 0
    if (typeof v === 'number' && typeof n === 'number') {
      if (v < n) {
        return -1
      } else if (v > n) {
        break
      }
    }
  }

  return 1
}
/**
 * @description webtool 的language和web的做个映射
 */
export function getLDwebtooLan() {
  const WEBTOOl_LANG_MAP = {
    zh: 'zh_cn',
    en: 'en',
    tw: 'zh_tw',
    ja: 'ja',
  }
  const boxLan = getLanguage()
  return WEBTOOl_LANG_MAP[boxLan]
}

